import React, {useMemo} from 'react'
import _ from 'lodash'

const DateTimeIndicator = ({now, selectedDate, dayCount = 1}) => {
  const [top, left, width] = useMemo(() => {
    const dayInMS = 60 * 60 * 24 * 1000
    let _now = now.clone().startOf('day')
    let _selDate = selectedDate.clone().startOf('day')

    let numOfDays = dayCount // 7 if weeks

    let top = 0
    let left = 0
    let width = 0
    if (_selDate.valueOf() <= _now.valueOf()) {
      top = ((now.valueOf() - _now.valueOf()) / dayInMS) * 100
      width = 100 / numOfDays
      left = _.clamp(_now.diff(_selDate, 'days') * width, 0, 100)
    }

    return [top, left, left < 100 ? width : 0]
  }, [now, selectedDate, dayCount])

  return (
    !!width && (
      <div className="datetime-indicator" style={{top: `${top}%`}}>
        <div className="time">{now.format('hh:mm a')}</div>
        <div className="circle"></div>
        <div className="dashed-line" style={{flexBasis: `${left}%`}}></div>
        <div className="solid-line" style={{flexBasis: `${width}%`}}></div>
      </div>
    )
  )
}

export default DateTimeIndicator
